import * as React from "react";
import { Outlet } from "react-router";

import { SubNav } from "@/components/ui/sub-nav";

/**
 * Admin · Platform (MV2-848, app/AdminIA; MV2-904, canvas 06 `admin/Platform`).
 * Health · Settings · Engagement are three routes under one sub-nav; Health's
 * readiness table is the SuperAdmin landing.
 */
export function AdminPlatformShell(): React.ReactElement {
  return (
    <div className="flex flex-col gap-4">
      <SubNav
        families={[
          {
            tabs: [
              { to: "/admin/platform/health", label: "Health" },
              { to: "/admin/platform/settings", label: "Settings" },
              { to: "/admin/platform/engagement", label: "Engagement" },
            ],
          },
        ]}
        className="border-b border-gray-200"
      />
      <Outlet />
    </div>
  );
}
